<div class="dialog-agent">
  <div mat-dialog-content class="">
    <div>
      <div class="w-100 d-inline-block text-center py-2">
        <i class="fas fa-exclamation-triangle fa-2x text-warning"></i>
      </div>
    </div>

    <div class="w-100 d-inline-block">
      <p class="p-3 m-0 bg-light text-dark fw-bold" [innerHTML]="data.staticMessages"></p>
    </div>
  </div>

  <div mat-dialog-actions class="w-100">
    <button mat-stroked-button color="primary" class="ms-auto" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CLOSE' | translate }}</span>
    </button>
  </div>
</div>
